// extracted by mini-css-extract-plugin
export var colorSquare = "_uh-0";
export var danger = "_uh-5";
export var lightPink = "_uh-8";
export var neutralBlue = "_uh-7";
export var neutralYellow = "_uh-6";
export var normal = "_uh-1";
export var primary = "_uh-2";
export var primaryLight = "_uh-3";
export var solidBlack = "_uh-g";
export var solidGreen = "_uh-b";
export var solidLightBlue = "_uh-d";
export var solidNavy = "_uh-c";
export var solidOrange = "_uh-f";
export var solidPink = "_uh-e";
export var solidRed = "_uh-9";
export var solidYellow = "_uh-a";
export var success = "_uh-4";